/* eslint-disable */
import { useEffect, useState } from "react";
import TableStyle from "../style/table.component";
import { Header } from "./interface/interface";

export interface SocialTableProps {
  headers: Header[];
  dataList: any[];
  selectedList: { id: number; nickname: string }[];
  setSelectedList: (v: { id: number; nickname: string }[]) => void;
}

const SocialTable = ({
  headers,
  dataList,
  selectedList,
  setSelectedList,
}: SocialTableProps) => {
  const handleList = (data: any) => {
    let newList = [...selectedList];
    if (selectedList.some((item) => item.id === data["userId"])) {
      newList = newList.filter((item) => +item.id !== +data["userId"]);
    } else {
      newList.push({ id: data["userId"], nickname: data["nickname"] });
    }
    setSelectedList(newList);
  };

  return (
    <TableStyle marginTop="30px">
      <thead>
        <tr>
          {headers.map((header: Header) => (
            <th key={header.value}>{header.text}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataList.map((data: any, index: number) => (
          <tr
            key={index}
            onClick={() => {
              handleList(data);
            }}
          >
            {headers.map((header) => (
              <td key={header.value}>
                {header.value === "club" ? (
                  data[header.value]?.name
                ) : header.value === "" ? (
                  <input
                    type="checkbox"
                    checked={selectedList.some(
                      (item) => item.id === data["userId"]
                    )}
                  />
                ) : (
                  data[header.value]
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </TableStyle>
  );
};

export default SocialTable;
